import React, { createContext, useContext } from 'react';
import { UserManagementService } from './Services/UserManagementService';

export interface UserManagementSession {
  user: {
    [key: string]: any;
  };
  accessToken?: string;
}

interface UserManagementContextType {
  service: UserManagementService;
  session: UserManagementSession | null;
}

export const UserManagementContext = createContext<UserManagementContextType | undefined>(undefined);

export const useUserManagementContext = () => {
  const context = useContext(UserManagementContext);
  if (!context) {
    throw new Error('useUserManagementContext must be used within a UserManagementProvider');
  }
  return context;
};
